'use client';
import * as React from 'react';
import {
  MentimeterLogoType,
  MentimeterSymbol,
} from '@mentimeter/ragnar-visuals';
import { useTranslations } from 'next-intl';
import { Device } from '@mentimeter/ragnar-device';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '../Wrapper/Button';
import { useReferralPropMapper } from '../../utils/useReferralPropMapper';
import { Clickable } from '../Wrapper/Clickable';
import { Wide } from '../Layout/Wide';
import { isAuthenticated, type ContentUserT } from '../../state/user';

interface HeaderSlimT {
  customCta?: string | undefined;
  user: ContentUserT;
}

export function HeaderSlim({ customCta: customText, user }: HeaderSlimT) {
  const referralPropMapper = useReferralPropMapper();
  const t = useTranslations('first_impression.legacy.common');
  const copy = customText || t('page_links.sign_up');
  return (
    <Box as="header">
      <Box
        top={0}
        zIndex={10}
        width="100%"
        alignItems="center"
        justifyContent="center"
        px="space4"
        py={['space4', null, 'space8']}
        bg="bg"
        height={4}
        borderBottomWidth="1px"
        borderStyle="solid"
        borderColor="borderWeak"
        as="nav"
      >
        <Wide
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Clickable
              href="/"
              data-testid="page-header-logo"
              aria-label={t('page_links.to_mentimeter_aria')}
              overflow="visible"
            >
              <Device.Match greaterThan={2}>
                <MentimeterLogoType width={200} />
              </Device.Match>
              <Device.Match lessThan={3}>
                <MentimeterSymbol width={46} height={46} />
              </Device.Match>
            </Clickable>
          </Box>
          <Box
            flexDirection="row"
            alignItems="center"
            width="200px"
            justifyContent="flex-end"
          >
            {!isAuthenticated(user) && (
              <Button
                ml="space4"
                variant="primary"
                data-testid="header-signup"
                {...referralPropMapper({ href: '/auth/signup' })}
              >
                {copy}
              </Button>
            )}
          </Box>
        </Wide>
      </Box>
    </Box>
  );
}
